__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dashboardsmartscripts";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@adjust/components", "17.9.0", () => (Promise.all([__webpack_require__.e(941), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(78)]).then(() => (() => (__webpack_require__(21941))))));
			register("@adjust/design-tokens", "6.12.0", () => (__webpack_require__.e(669).then(() => (() => (__webpack_require__(67669))))));
			register("@adjust/mfe-shared-context", "5.0.0", () => (Promise.all([__webpack_require__.e(837), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(824), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(15837))))));
			register("@tanstack/react-query", "5.59.16", () => (Promise.all([__webpack_require__.e(417), __webpack_require__.e(318), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(6417))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(569), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(74117))))));
			register("react-router-dom", "6.27.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(9), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(30009))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};